import { create } from 'zustand'
import type { AuthenticatedUser } from '@/api/auth'

/**
 * AuthStatus — tri-state: `loading` пока не пришёл ответ /me, `authenticated`
 * после успешной hydration или login, `unauthenticated` после 401 или
 * logout. Промежуточное состояние загрузки критично: без него guard-компонент
 * отправил бы авторизованного пользователя на /login в первый кадр.
 */
export type AuthStatus = 'loading' | 'authenticated' | 'unauthenticated'

interface AuthState {
  user: AuthenticatedUser | null
  status: AuthStatus
  /** Зафиксировать успешную аутентификацию (после /me или после login). */
  setUser: (user: AuthenticatedUser) => void
  /** Пометить сессию как отсутствующую (401 / logout / hydration failure). */
  clear: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  status: 'loading',
  setUser: (user) => set({ user, status: 'authenticated' }),
  clear: () => set({ user: null, status: 'unauthenticated' }),
}))

/** True если есть активный пользователь в сторе. */
export const selectIsLoggedIn = (s: AuthState) => s.status === 'authenticated'
